export enum SegmentoJustica {
  SUPREMO_TRIBUNAL_FEDERAL = <any>  'SUPREMO_TRIBUNAL_FEDERAL',
  CONSELHO_NACIONAL_JUSTICA = <any>  'CONSELHO_NACIONAL_JUSTICA',
  SUPERIOR_TRIBUNAL_JUSTICA = <any>  'SUPERIOR_TRIBUNAL_JUSTICA',
  JUSTICA_FEDERAL = <any>  'JUSTICA_FEDERAL',
  JUSTICA_TRABALHO = <any>  'JUSTICA_TRABALHO',
  JUSTICA_ELEITORAL = <any>  'JUSTICA_ELEITORAL',
  JUSTICA_MILITAR_UNIAO = <any>  'JUSTICA_MILITAR_UNIAO',
  JUSTICA_ESTADUAL = <any>  'JUSTICA_ESTADUAL',
  JUSTICA_MILITAR_ESTADUAL = <any>  'JUSTICA_MILITAR_ESTADUAL'
}
